import { adminAxios } from './api';

export const getAdminStats = async () => {
  try {
    const response = await adminAxios.get('/admin/stats');
    return response.data.data || response.data;
  } catch (error) {
    console.error("API error in getAdminStats:", error);
    return null;
  }
};

const getWebhookData = async (source, page = 1, limit = 10, startDate = "", endDate = "", stateCode = "", districtCode = "") => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (stateCode) params.append('state_code', stateCode);
    if (districtCode) params.append('district_code', districtCode);

    const response = await adminAxios.get(`/webhook/${source}?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error(`API error in getWebhookData for ${source}:`, error);
    return { success: false, data: [], count: 0 };
  }
};

export const getUwinData = (...args) => getWebhookData('uwin', ...args);
export const getJananiData = (...args) => getWebhookData('janani', ...args);
export const getRbskData = (...args) => getWebhookData('rbsk', ...args);
export const getOthersData = (...args) => getWebhookData('others', ...args); // Add this assuming OthersDataPoints needs it
